import { chains, Chain } from 'config/chains'
import { currentNetwork } from 'utils'
import { NetworkPurpose } from 'types'

export const AIRDROP_CHAINS = currentNetwork === NetworkPurpose.Mainnet
    ? [chains.BSC, chains.POLYGON]
    : [chains.BSC_TESTNET, chains.POLYGON_TESTNET]

export const AIRDROP_CHAINS_BY_ID = Object.fromEntries(AIRDROP_CHAINS.map((chain: Chain) => [chain.chainId, chain]))